import {Component, EventEmitter, inject, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {BaseComponent, WmsMessageComponent, WmsSpinnerComponent, WmsTypeaheadComponent} from "@wms/components";
import {FormsModule} from "@angular/forms";
import {DialogService, ServiceFactoryService} from "@wms/services";
import {TemplateFilter} from "@wm/components-base";
import { environment } from "@wms/app";
import {CarouselModule} from "ngx-bootstrap/carousel";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {filter, forEach, toUpper} from "lodash-es";
import {VARIABLE_CONSTANTS} from "@wms/variables";
import { replace } from '@wms/app/core';

@Component({
  selector: 'wms-page-template',
  standalone: true,
  imports: [CommonModule, WmsSpinnerComponent, WmsMessageComponent, FormsModule, NgOptimizedImage, TemplateFilter, CarouselModule, WmsTypeaheadComponent, TooltipModule],
  templateUrl: './page-template.component.html',
  styleUrls: ['./page-template.component.less']
})
export class PageTemplateComponent extends BaseComponent implements OnInit {
  @Input() newPage: any
  @Input() isPrefabType: boolean
  @Input() template: any
  @Input() newPageTypes: any
  @Input() templateData: any
  @Input() stepCounter: number;
  @Input() isTemplateBundleType: any;
  @Input() tempCategory: any;
  @Input() templatePlatformType: string;
  @Input() selectedOrganization: any;
  @Input() loadingTemplates: boolean;
  @Input() preDefinedTemplates: any;
  @Input() templateType: string;
  @Input() allTemplates: any;
  @Input() isWeb: boolean;
  @Input() isMobile: boolean;
  @Input() activeTemplate: any;
  @Input() pageLayout: any;
  @Input() ctrlScope: any;
  @Input() baseScreen: string;
  @Input() fileAddMessage: any;
  @Input() createdVariable: any;
  @Input() templateWidgets: any;
  @Input() selectedWidget: any;
  @Input() preDefinedTemplateSelected: any;
  @Input() listImage: string;
  @Input() propertyName: any;
  @Input() model: any;
  @Input() showTemplatePreview: boolean;
  @Input() fields: any
  @Input() layouts: any;
  @Input() activeLayout: any;
  baseURL: string;
  carouselInterval: number;
  searchResults: any[] = [];
  dialogService: DialogService;
  isMobileApplicationType: boolean;
  @Output() selectTemplate = new EventEmitter<any>();
  @Output() previewTemplate = new EventEmitter<any>();
  @Output() importTemplateBundle = new EventEmitter<any>();
  @Output() changeNewPageType = new EventEmitter<any>();
  @Output() onVariablePropertyChange = new EventEmitter<any>();
  @Output() selectTemplateWidget = new EventEmitter<any>();
  @Output() setWidgetProp = new EventEmitter<any>();
  @Output() getTemplates = new EventEmitter<any>();
  @Output() layoutSelected = new EventEmitter<any>();
  @Output() getServiceEntitie = new EventEmitter<any>();
  @Output() clearServiceEntitie = new EventEmitter<any>();

  @ViewChild('templatelist', {static: true}) templatelistTemplate: TemplateRef<any> | undefined;
  @ViewChild('newPageDlg', {static: true}) newPageDlgTemplate: TemplateRef<any> | undefined;
  @ViewChild('previewAndName', {static: true}) previewAndNameTemplate: TemplateRef<any> | undefined;
  @ViewChild('selectLayout', {static: true}) selectLayoutTemplate: TemplateRef<any> | undefined;
  @ViewChild('selectTemplateLayout', {static: true}) selectTemplateLayoutTemplate: TemplateRef<any> | undefined;
  @ViewChild('templateContext', {static: true}) templateContextTemplate: TemplateRef<any> | undefined;
  @ViewChild('layoutOptions', {static:true}) layoutOptionsTemplate: TemplateRef<any> | undefined;

  protected platformType: string;
  filteredDataSources: any;
  @Input() selectedDataSource: any
  serviceFactory: ServiceFactoryService
  dataSource: any
  variableServiceTypeMap: any = {
    'RestService': 'web',
    'JavaService': 'java',
    'WebSocketService': 'web',
    'SoapService': 'web',
    'DataService': 'database',
    'OpenAPIService': 'openapi'
  };
  placeholder: string = this.locale.LABEL_ENTER_PAGE_NAME

  constructor() {
    super()
    this.isMobileApplicationType = this.projectService.isNativeMobileApplicationType();
    this.dialogService = inject(DialogService);
    this.serviceFactory = inject(ServiceFactoryService);
    this.baseURL = environment.SERVICES_BASE_PATH;
    this.platformType = this.projectService.getDetails().platformType;
  }

  ngOnInit(): void {

    this.serviceFactory.getServicesWithType().then((services: any) => {

      this.dataSource = filter(services, (service) => {
        return service.type !== VARIABLE_CONSTANTS.SERVICE_TYPE_SECURITY && service.type !== VARIABLE_CONSTANTS.SERVICE_TYPE_MODEL && service.type !== VARIABLE_CONSTANTS.SERVICE_TYPE_REST && service.name !== VARIABLE_CONSTANTS.SERVICE_TYPE_MYJAVA;
      });

      forEach(this.dataSource, (service: any) => {
        service.serviceType = this.variableServiceTypeMap[service.type];
        service.displayType = this.locale['SERVICE_NAME'][toUpper(service.type)];
      });

      if (this.projectService.isNativeMobileApplicationType()) {
        this.dataSource = filter(this.dataSource, (service) => {
          return service.serviceType !== 'openapi';
        });
      }
      this.filteredDataSources = this.dataSource;
    })
  }

  getServiceEntities($event: any) {
    this.getServiceEntitie.emit($event);
  }

  clearServiceEntities() {
    this.clearServiceEntitie.emit();
  }

  secondaryTemplate(): any {
    switch (this.templateType) {
      case 'templatelist':
        return this.templatelistTemplate;
      case 'previewAndName':
        return this.previewAndNameTemplate;
      case 'selectLayout':
        return this.selectLayoutTemplate;
      case 'selectTemplateLayout':
        return this.selectTemplateLayoutTemplate;
    }

  }

  primaryTemplate(): any {
    switch (this.baseScreen) {
      case 'newPageDlg':
        return this.newPageDlgTemplate;
      case 'templateContext':
        return this.templateContextTemplate;
      case 'layoutOptions':
        return this.layoutOptionsTemplate;
    }

  }

  selectTemplateInLayout(template: any) {
    this.selectTemplate.emit(template)
  }

  importTemplateBundleBtn($event: any) {
    $event.stopPropagation();
    $event.preventDefault();
    this.dialogService.open('uploadResourcesDialog',"templatebundles");
  }

  previewTemplateLayout($event: any, template: any) {
    this.previewTemplate.emit({event: event, template: template})

  }

  closeTemplatePreview() {
    this.showTemplatePreview = false;
  }

  changeNewPageTypeFun(pageType: any) {
    this.placeholder = replace(this.locale.LABEL_ENTER_NEW_PAGE_NAME, [this.locale[pageType.label]])
    this.changeNewPageType.emit(pageType);

  }

  onVariablePropertyChangefun(propertyName: any, value: any) {
    this.onVariablePropertyChange.emit({propertyName: propertyName, value: value})

  }

  selectTemplateWidgetFun(widget: any) {
    this.selectTemplateWidget.emit(widget)
  }

  setWidgetProps(prop: any) {
    this.setWidgetProp.emit(prop)
  }

  fetchTemplates(isWeb: boolean) {
    this.getTemplates.emit(isWeb)
  }
  selectedLayout(layout: any) {
    this.layoutSelected.emit(layout);
  }
  getSearchResults( key:any  ){
    this.template.category = key;
    this.searchResults = filter(this.allTemplates, (template:any) => {
      return template.type === this.newPage.type && template.category === key
    });
  }
}
